import withAPIAction from 'utils/withAPIAction'
import { getDataListAction, updateDataAction } from './actions'

import { GetDataListReq, UpdateDataReq } from './types'

import { verifyReqNoProject } from 'utils/verify'

export const getDataList = (token: string, data: GetDataListReq) => {
  const isValid = verifyReqNoProject(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetDataListReq>({
    method: 'POST',
    path: 'GetDefaultEmail',
    data,
    token: `Bearer ${token}`,
  })(getDataListAction)
}

export const updateData = (token: string, data: UpdateDataReq) => {
  const isValid = verifyReqNoProject(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<UpdateDataReq>({
    method: 'POST',
    path: 'UpdateDefaultEmail',
    data,
    token: `Bearer ${token}`,
  })(updateDataAction)
}
